import React from "react";
import { ReactNode } from "react";

function ChartBox({ children }: { children: ReactNode }) {
  return <div className="chart">{children}</div>;
}

export default ChartBox;
